type ResolvableDiscount = {
  amount: number;
  amountType: "currency" | "percentage";
};

/**
 * Resolves a discount definition to a concrete money amount.
 *
 * - `percentage`: a share of the provided base total (e.g. 20% of the line total).
 * - `currency`: a fixed amount per unit, multiplied by the quantity.
 *
 * Shared by list pricing (`getHybridBillingProductDiscount`, quantity 1 per unit)
 * and basket allowance pricing (`distributeUnitPriceAllowance`) so the
 * percentage-vs-currency rule lives in one place.
 *
 * Note: order discounts do NOT use this — a currency order discount is a flat
 * basket-wide amount, not a per-unit one.
 */
export function resolveDiscountAmount(
  discount: ResolvableDiscount,
  baseTotal: number,
  quantity: number
): number {
  return discount.amountType === "percentage"
    ? baseTotal * (discount.amount / 100)
    : discount.amount * quantity;
}
